import { useEffect } from "react";

export default function useReveal(trigger = null) {
  useEffect(() => {
    const elements = document.querySelectorAll(
      "[data-reveal]:not(.is-visible)",
    );

    if (!elements.length) return undefined;

    // If IntersectionObserver is unavailable, never leave content hidden.
    if (!("IntersectionObserver" in window)) {
      elements.forEach((element) => element.classList.add("is-visible"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -5% 0px",
      },
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [trigger]);
}
